export default function CareButton({buttonName, dark, buttonClass, handleButtonClick, type = "button" }) {
    return (
        <button
        type={type}
         className={` px-8 py-2 uppercase border text-center transition duration-300 ease-in-out w-full lg:w-1/2
            ${dark ? 
                'progress-button-light border-slate-50 text-slate-50' : 
                'border-black text-black progress-button-dark'
            } 
            ${buttonClass}
            `}
      onClick={handleButtonClick}

        >
            {buttonName}
        </button>
    );
}